import { Navigate, Outlet, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { configNext, type IConfigResult } from 'app/shared/layouts/GlobalAccessLayout/config/config'
import { ruleSubscription } from 'app/shared/layouts/GlobalAccessLayout/config/ruleSubscription'

export const SubscriptionAccessLayout = observer(() => {
  const entities = useEntitiesContext()
  const { organizationStore, subscriptionStore, usersStore } = entities
  const location = useLocation()
  const [entitiesReady, setEntitiesReady] = useState(false)

  useEffect(() => {
    Promise.all([
      organizationStore.initPromise,
      subscriptionStore.initPromise,
      usersStore.initPromise,
    ]).then(() => {
      setEntitiesReady(true)
    })
  }, [])

  if (!entitiesReady) return <SpinnerLoader ariaLabel={'SubscriptionAccessLayout'} />

  const to: IConfigResult = {
    path: location.pathname,
    query: new URLSearchParams(location.search),
  }

  const redirect = ruleSubscription(entities, to, configNext)?.path ?? ''
  const next = redirect && redirect !== location.pathname ? redirect : ''

  return next ? <Navigate to={next} replace /> : <Outlet />
})
